import { ANONYMOUS_VIEWER_ID } from 'containers/profile-views/types/profileViews'
import { useProfileById } from 'containers/profile/hooks/useProfile'
import { Avatar } from 'containers/recommendations/Avatar'
import { useMemo } from 'react'
import { joinWithSlash } from 'utilities/links'

interface AvatarContainerProps {
  id: string
  size?: number
}

export const AvatarContainer = ({ id, size = 48 }: AvatarContainerProps) => {
  const { profile, isLoading } = useProfileById(id)

  const profileInfo = useMemo(() => {
    if (id === ANONYMOUS_VIEWER_ID) {
      return {
        avatar: '/assets/avatar.png',
        to: undefined,
      }
    }

    return {
      avatar: profile?.avatar,
      to: joinWithSlash(profile?.username?.toLocaleLowerCase()),
    }
  }, [id, profile?.avatar, profile?.username])

  return (
    <Avatar
      image={profileInfo.avatar}
      isLoading={isLoading}
      size={size}
      to={profileInfo.to}
    />
  )
}
